import { TFunction } from 'i18next'

import { DataClassName } from '@/Data/const'

export const getEntityLabelKey = (dataClassName: string) => {
  switch (dataClassName) {
    case DataClassName.ACTIVITY:
      return 'common.entity.activity'
    case DataClassName.ADDRESS:
      return 'common.entity.address'
    case DataClassName.COMPANY:
      return 'common.entity.company'
    case DataClassName.CONTACT:
      return 'common.entity.contact'
    case DataClassName.DOCUMENT:
      return 'common.entity.document'
    case DataClassName.FOLLOW_UP:
      return 'common.entity.followUp'
    case DataClassName.GLOBAL_RESULT:
      return 'common.entity.globalResult'
    case DataClassName.INVOICE:
      return 'common.entity.invoice'
    case DataClassName.LEAD:
      return 'common.entity.lead'
    case DataClassName.LIST:
      return 'common.entity.list'
    case DataClassName.OPPORTUNITY:
      return 'common.entity.opportunity'
    case DataClassName.ORDER:
      return 'common.entity.order'
    case DataClassName.PERSON:
      return 'common.entity.person'
    case DataClassName.QUOTE:
      return 'common.entity.quote'
    case DataClassName.TICKET:
      return 'common.entity.ticket'
    default:
      return ''
  }
}

export const formatCount = (
  t: TFunction,
  count: number,
  dataClassName: string,
) => `${count} ${t(getEntityLabelKey(dataClassName), { count })}`
